import { useAuth0 } from '@auth0/auth0-react'
import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import Delay from '../../Components/Delay'
import { useGlobalState } from '../GlobalContext'
import AccessDenied from '../../Components/AccessDenied'

interface AuthRouteProps {
  component: any
  path: string
  exact: boolean
}

const AuthRoute: React.FunctionComponent<AuthRouteProps> = ({
  component: Component,
  ...rest
}) => {
  const pathName = window.location.pathname
  const fwdToPath = `/?fwdTo=${encodeURIComponent(pathName)}`
  const { isAuthenticated, isLoading: auth0IsLoading } = useAuth0()
  const { isLoggedIn } = useGlobalState()

  return (
    <Route
      {...rest}
      render={(props) =>
        auth0IsLoading ? (
          <></>
        ) : isAuthenticated && isLoggedIn ? (
          <Component {...props} />
        ) : (
          <Delay waitBeforeShow={1000}>
            {!auth0IsLoading && !isAuthenticated ? (
              <Redirect to={fwdToPath} />
            ) : (
              <AccessDenied />
            )}
          </Delay>
          // <Redirect to="/" />
        )
      }
    />
  )
}

export default AuthRoute
